import React, { Fragment } from 'react';

export const about = () => {
  return (
    <Fragment>
      <h1>About This Web-Application</h1>
      <p>
        This is a prototype search engine for identifying anonymous users from
        different plannets.
      </p>
      <p>Version: 2.1.0</p>
    </Fragment>
  );
};
